module.exports = __webpack_public_path__ + "746c3af7a145a09239a36e5ef61cfea0.svg";